const initWorkoutBlock = () => {
  const imagesContainer = document.querySelector('.exercises__images');
  if (!imagesContainer) return;

  const subtitles = document.querySelectorAll('.exercises__subtitle p');
  const toggleButtons = document.querySelectorAll(
    '.exercises__subtitle .toggle-btn'
  );

  const resetSubtitleState = (parent, subtitle, toggleButton, plus) => {
    parent.classList.remove('expanded');
    subtitle.style.minHeight = '';
    plus.classList.remove('open');
    subtitle.classList.add('hidden');
    toggleButton.classList.add('hidden');
  };

  const showActiveSubtitle = (subtitle, toggleButton) => {
    subtitle.classList.remove('hidden');
    if (subtitle.scrollHeight > subtitle.clientHeight) {
      toggleButton.classList.remove('hidden');
    }
  };

  const updateSubtitle = activeIndex => {
    subtitles.forEach((subtitle, index) => {
      const parent = subtitle.closest('.exercises__subtitle-wrap');
      const toggleButton = toggleButtons[index];
      const plus = parent.querySelector('.plus');

      resetSubtitleState(parent, subtitle, toggleButton, plus);

      if (index + 1 === activeIndex) {
        showActiveSubtitle(subtitle, toggleButton);
      }
    });
  };

  const toggleSubtitle = parent => {
    const content = parent.querySelector('p');
    const plus = parent.querySelector('.plus');

    if (parent.classList.contains('expanded')) {
      parent.classList.remove('expanded');
      content.style.minHeight = '';
      plus.classList.remove('open');
      return;
    }

    content.style.minHeight = `${content.scrollHeight}px`;
    parent.classList.add('expanded');
    plus.classList.add('open');
  };

  updateSubtitle(1);

  const isRTL = document.documentElement.dir === 'rtl';

  $(imagesContainer)
    .not('.slick-initialized')
    .slick({
      centerMode: true,
      centerPadding: '26.8%',
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      infinite: true,
      rtl: isRTL,
      responsive: [
        {
          breakpoint: 1440,
          settings: { centerPadding: '27.8%' }
        },
        {
          breakpoint: 1281,
          settings: { centerPadding: '24%' }
        },
        {
          breakpoint: 991,
          settings: {
            centerMode: false,
            centerPadding: '0',
            arrows: false
          }
        }
      ]
    });

  $(imagesContainer).on('afterChange', (_event, slick, currentSlide) => {
    const activeSlide = slick.$slides.get(currentSlide);
    const activeIndex = parseInt(activeSlide.getAttribute('data-active'), 10);
    updateSubtitle(activeIndex);
  });

  toggleButtons.forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();
      toggleSubtitle(button.closest('.exercises__subtitle-wrap'));
    });
  });
};

document.addEventListener('DOMContentLoaded', initWorkoutBlock);
